import {
  GET_HOW_TO_DOCUMENTATION_REQUEST,
  GET_HOW_TO_DOCUMENTATION_SUCCESS,
  GET_HOW_TO_DOCUMENTATION_FAILURE,
  GET_CLIENT_SUPPORT_DOCUMENTS_REQUEST,
  GET_CLIENT_SUPPORT_DOCUMENTS_SUCCESS,
  GET_CLIENT_SUPPORT_DOCUMENTS_FAILURE,
} from '../actions/how_to_documentation'

export function fetchHowToDocumentation(
  state = {
    isFetching: false,
    response: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case GET_HOW_TO_DOCUMENTATION_REQUEST:
      return {
        ...state,
        response: null,
        isFetching: true,
        errorMessage: null,
      }
    case GET_HOW_TO_DOCUMENTATION_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        response: action.response,
      }
    case GET_HOW_TO_DOCUMENTATION_FAILURE:
      return {
        ...state,
        errors: null,
        response: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export function fetchClientSupportDocuments(
  state = {
    isFetching: false,
    response: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case GET_CLIENT_SUPPORT_DOCUMENTS_REQUEST:
      return {
        ...state,
        response: [],
        isFetching: true,
        errorMessage: null,
      }
    case GET_CLIENT_SUPPORT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        response: action.response,
      }
    case GET_CLIENT_SUPPORT_DOCUMENTS_FAILURE:
      return {
        ...state,
        errors: null,
        response: [],
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
